module.exports = __webpack_public_path__ + "img/mp.e91a78e8.svg";